<template>
  <section
    class="py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 bg-gradient-to-br from-[#0b105d] to-[#0c1260]"
  >
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-stretch">
        <!-- Our Vision -->
        <div class="relative group" data-aos="fade-right">
          <div
            class="absolute inset-0 bg-gradient-to-r from-[#fe6d0d8c] to-[#ffb47c] rounded-2xl sm:rounded-3xl blur-xl opacity-50 group-hover:opacity-55 transition-opacity"
          ></div>
          <div
            class="relative h-full glass-morphism-dark rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 border border-[#f4f4f4]/10"
          >
            <div
              class="absolute top-0 right-0 w-24 h-24 sm:w-32 sm:h-32 bg-[#fe6d0d]/30 rounded-full blur-3xl opacity-20"
            ></div>
            <div class="relative z-10">
              <div class="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <div
                  class="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#fe6d0d] to-[#ffb47c] rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6 shadow-lg"
                >
                  <EyeIcon class="w-6 h-6 sm:w-7 md:w-8 md:h-8 text-white" />
                </div>

                <h3
                  class="text-xl sm:text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] mb-4 sm:mb-6"
                >
                  {{ $t('aboutUsPage.Vision') }}
                </h3>
              </div>
              <h3
                class="text-xl sm:text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] mb-4 sm:mb-6"
              >
                {{ $t('aboutUsPage.ourVision').split(':')[0] }}
              </h3>
              <p class="text-[#f4f4f4]/90 text-sm sm:text-base md:text-lg leading-relaxed">
                {{
                  $t('aboutUsPage.ourVision').includes(':')
                    ? $t('aboutUsPage.ourVision')
                        .substring($t('aboutUsPage.ourVision').indexOf(':') + 1)
                        .trim()
                    : $t('aboutUsPage.ourVision')
                }}
              </p>
            </div>
          </div>
        </div>

        <!-- Toruk Magic Deep Tech -->
        <div class="relative group" data-aos="fade-left">
          <div
            class="absolute inset-0 bg-gradient-to-r from-[#ffb47c] to-[#fe6d0d8c] rounded-2xl sm:rounded-3xl blur-xl opacity-50 group-hover:opacity-55 transition-opacity"
          ></div>
          <div
            class="relative h-full glass-morphism-dark rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 border border-[#f4f4f4]/10"
          >
            <div
              class="absolute bottom-0 left-0 w-24 h-24 sm:w-32 sm:h-32 bg-[#ffb47c]/30 rounded-full blur-3xl opacity-20"
            ></div>
            <div class="relative z-10">
              <div class="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <div
                  class="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#ffb47c] to-[#fe6d0d] rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6 shadow-lg"
                >
                  <TargetIcon class="w-6 h-6 sm:w-7 md:w-8 md:h-8 text-white" />
                </div>
                <h3
                  class="text-xl sm:text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#ffb47c] to-[#fe6d0d] mb-4 sm:mb-6"
                >
                 {{ $t('aboutUsPage.Mission') }}
                </h3>
              </div>
              <h3
                class="text-xl sm:text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#ffb47c] to-[#fe6d0d] mb-4 sm:mb-6"
              >
                {{ $t('aboutUsPage.ourMission').split(':')[0] }}
              </h3>
              <p class="text-[#f4f4f4]/90 text-sm sm:text-base md:text-lg leading-relaxed">
                {{
                  $t('aboutUsPage.ourMissionDescription').includes(':')
                    ? $t('aboutUsPage.ourMissonDescription')
                        .substring($t('aboutUsPage.ourMissionDescription').indexOf(':') + 1)
                        .trim()
                    : $t('aboutUsPage.ourMissionDescription')
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { EyeIcon, TargetIcon } from 'lucide-vue-next'
</script>

<style scoped>
.glass-morphism-dark {
  background: rgba(244, 244, 244, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(244, 244, 244, 0.1);
}
</style>
